
export class ContentPreview {
   private html = '';
  constructor() {}

  setHtmlcontent(content:string) {
    this.html = content;
  }

  getHtmlContent():string {
      return this.html;
  }

}
